// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"37d0723b","158":"a5c16e7c","424":"94f6ef88","453":"24d1407f","577":"1b4ea3a9","629":"bd615ef1","691":"d95e8dae","982":"0ada027d"}[chunkId] + ".chunk.js";
};